const Expense = {
    amount: 0,
    description: '',
    date: ''
}

export default Expense;